var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"production-professional","route":"/reports/billing-production-professional","file-name":"producao-por-profissional.xlsx","period-label":"Período do atendimento","columns":_vm.columns,"default-days":30,"show-professional":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }